// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19g3S","content":"styles_content__MRcgw"};